<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
		<div class="back_left" @click="$router.back()"></div>
		<div class="big_tit">{{$t('feng.area')}}</div>
		<div class="top_right">
			<span  @click="$router.push('/order')">
				<van-icon name="todo-list-o" size="25"/>
			</span>
			<!-- <span v-if="area" @click="$router.push('/item/'+area.id)" style="margin-left: 8px;">
				<van-icon name="tosend" size="25"/>
			</span> -->
		</div>
    </div>
<!-- 	<div class="head-tabs">
	    <a href="#/vip" class="tab-item ">{{$t('income.title2')}}</a>
	    <a href="#/item" class="tab-item active">{{$t('income.title3')}}</a>
	    <a href="#/order" class="tab-item">{{$t('income.investr')}}</a>
	</div> -->
	<div>
	    <ul class="hall" v-if="list">
	        <li v-for="(item, index) in list" @click="$router.push('/buy/'+item.id)">
				<i class="iconfont fa-icon icon-xingxing1"></i> 
				<img class="W80H80"
	                    :src="item.img"
	                    lazy="loaded" style="border-radius: 8px;object-fit: cover;width: 60px; height: 60px; margin-right: 5px;">
	            <div class="content">
	                <div class="cp-name">{{item.jt}}</div>
	                <span class="frequency">{{$t('pro.every')}} {{item.day}} {{$t('pro.minute')}}</span>
	                <div>
						<div v-if="item.deal==1" class="time">{{$t('pro.ing')}}</div>
	                    <div v-if="item.deal==0" class="time">
							<van-count-down :time="item.time*1000" format="HH:mm:ss" />
						</div>
	                </div>
	            </div>
	        </li>
	    </ul>
	</div>
	
  </div>
</template>
<script>
import Fetch from '../../utils/fetch';
import Vue from 'vue';
import {Tab, Tabs, Progress, Empty, Dialog, Field,Icon,CountDown} from 'vant';

Vue.use(Tab).use(Tabs).use(Progress).use(Empty).use(Dialog).use(Field).use(Icon).use(CountDown);
export default {
  name: "item",
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      tabs: [
        {name:0,title:this.$t('item.all')}
      ],
      active: 0,
      data: [],
	  area:null,
	  vip:null,
	  list:null,
      listLength: 0,
      show_tz: false,
      number: "",
      sku: []
    }
  },
  created() {
	this.$parent.footer('item');
  },
  mounted() {
    var type = 0;
    if (this.$router.history.current.query.type) {
		this.active = parseInt(this.$router.history.current.query.type);
		type = this.$router.history.current.query.type;
    }
    this.start(type);
  },
  methods: {
	  
    start(type) {
		Fetch('/index/item_search', {
			name: "",
			cate: type
		}).then(r => {
			this.data = r.data;
			this.vip = r.data.vip;
			this.list = r.data.list;
			if(this.list && this.list.length>0){
				this.area = r.data.list[0];
			}
			this.tabs = [{name:'0',title:this.$t('item.all')}].concat(r.data.cates);
			this.listLength = r.data.list.length;
		})
    },
    sort(type) {
		this.start(type);
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .van-cell {
  padding: 15px 26px;
}

.red_top_bg {
  height: 44px;
  background-size: 100% 100%;
  position: relative;
}

.basic_wrap {
  position: relative;
}
.hall{
	padding: 5px 1%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	li{
		background: #fff;
		position: relative;
		width: 48%;
		margin: 1%;
		display: -webkit-inline-box;
		display: -ms-inline-flexbox;
		display: inline-flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		padding: 10px 0;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #000;
	}

	li .imgStyle{
		display: inline-block;
		width: 60px;
		height: 60px;
		margin-right: 5px
	}

	li .content{
		display: inline-block;
		width: 106px;
		overflow: hidden;
		line-height: 20px;
	}

	li .content .cp-name{
		font-size: 13px
	}

	li .content .frequency{
		display: block;
		margin: 2px 0
	}

	li .content .time{
		font-size: 15px;
		line-height: 20px
	}
	li .content .tip{
		font-size: 12px
	}
}
.hall{
    margin-bottom: 53px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap
}
/deep/ .van-count-down{
	font-size: 16px;
}
</style>
